module.exports = __webpack_public_path__ + "img/logo-w.9ea9a430.png";